// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_1Uj","cls2":"RelatedPapers-cls2_KOo RelatedPapers-cls1_1Uj"};